import { FunctionComponent } from "react";
import { IconProps } from "./constants";

const Hamburger: FunctionComponent<IconProps> = ({
  width = 14,
  height = 13,
  color = "#122A26",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1H13M1 6.5H13M1 12H13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Hamburger;
